import {
  GRID_COLS,
  GRID_ROWS,
  BRICK_TYPES,
} from '../core/Constants';

/**
 * Encodes the 11x16 Brick Grid into a WebGL 2D Data Texture
 * Allows the 100% Fragment Shader to sample brick properties instantly
 */
export class BrickTexture {
  constructor(gl) {
    this.gl = gl;
    this.width = GRID_COLS;   // 11
    this.height = GRID_ROWS;  // 16
    this.data = new Uint8Array(this.width * this.height * 4);
    this.texture = gl.createTexture();

    gl.bindTexture(gl.TEXTURE_2D, this.texture);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);

    this.upload();
  }

  updateFromBricks(bricks) {
    // Fill the Uint8Array buffer
    for (let i = 0; i < bricks.length; i++) {
      const b = bricks[i];
      const index = (b.row * this.width + b.col) * 4;

      if (b.destroyed || b.type === BRICK_TYPES.EMPTY) {
        this.data[index + 0] = 0; // Type 0 = empty
        this.data[index + 1] = 0; // Flash
        this.data[index + 2] = 0; // Hits
        this.data[index + 3] = 0; // Destroyed
      } else {
        this.data[index + 0] = b.type;
        this.data[index + 1] = Math.floor(Math.min(1.0, Math.max(0.0, b.flashTimer)) * 255);
        this.data[index + 2] = Math.max(0, b.hitsRemaining);
        this.data[index + 3] = 255; // Active
      }
    }

    this.upload();
  }

  upload() {
    const gl = this.gl;
    gl.bindTexture(gl.TEXTURE_2D, this.texture);
    gl.texImage2D(
      gl.TEXTURE_2D,
      0,
      gl.RGBA,
      this.width,
      this.height,
      0,
      gl.RGBA,
      gl.UNSIGNED_BYTE,
      this.data
    );
  }

  bind(unit = 0) {
    const gl = this.gl;
    gl.activeTexture(gl.TEXTURE0 + unit);
    gl.bindTexture(gl.TEXTURE_2D, this.texture);
  }
}
